// Entry point for the build script in your package.json
// Initialiser Sentry en premier pour capturer toutes les erreurs
import "./sentry"

import "@hotwired/turbo-rails"
import "./controllers"
import "trix"
import "@rails/actiontext"
import "flowbite/dist/flowbite.turbo.js";
import 'flowbite';
import Swal from 'sweetalert2'
window.Swal = Swal
